<div class="breadcrumb-area" data-uiid="new-eff-breadcrumbs">
    <span class="section bold">
        <span [title]="'controls.effBreadcrumbInfo.controlIdentifier' | transloco" data-uiid="new-eff-breadcrumbs-control-identifier">{{
            effectivenessModel.controlIdentifier
        }}</span>
        <span [title]="'controls.effBreadcrumbInfo.controlName' | transloco" data-uiid="new-eff-breadcrumbs-control-name">{{
            effectivenessModel.controlName
        }}</span>
    </span>

    <span class="separator">|</span>

    <span class="section">
        <span [title]="'controls.effBreadcrumbInfo.testPlanName' | transloco" data-uiid="new-eff-breadcrumbs-testplan-name">{{
            effectivenessModel.name
        }}</span>
        <span [title]="'controls.effBreadcrumbInfo.startDate' | transloco" data-uiid="new-eff-breadcrumbs-testplan-start-date"
            >({{ effectivenessModel.startDate | dateFormat }}</span
        >
        <span class="mx-0">-</span>
        <span [title]="'controls.effBreadcrumbInfo.endDate' | transloco" data-uiid="new-eff-breadcrumbs-testplan-end-date"
            >{{ effectivenessModel.endDate | dateFormat }})</span
        >
    </span>

    <span class="separator">|</span>

    <span class="section">
        <span [title]="'controls.effBreadcrumbInfo.periodName' | transloco" data-uiid="new-eff-breadcrumbs-testplan-period-name">{{
            effectivenessModel.groupName
        }}</span>
    </span>
</div>
